'use client';

import { c as _c } from "react/compiler-runtime";
import type { GetRecommendationsQuery } from '@data-access/lib/gql/cart/documents';
import { GetRecommendationsDocument } from '@data-access/lib/gql/cart/documents';
import { useGraphQL } from '@data-access/lib/graphql-query';
export function useAppExperienceRecommendation(publicId) {
  const $ = _c(8);
  let t0;
  if ($[0] !== publicId) {
    t0 = {
      input: {
        id: publicId,
        count: 1,
        type: "experience"
      }
    };
    $[0] = publicId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      enabled: false,
      select: selectRecommendations
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    refetch
  } = useGraphQL(GetRecommendationsDocument, t0, t1);
  let t2;
  if ($[3] !== refetch) {
    t2 = () => {
      refetch().catch(_temp);
    };
    $[3] = refetch;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const loadRecommendation = t2;
  let t3;
  if ($[5] !== data || $[6] !== loadRecommendation) {
    t3 = {
      recommendation: data,
      loadRecommendation
    };
    $[5] = data;
    $[6] = loadRecommendation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp() {}
function selectRecommendations({
  getRecommendations
}: GetRecommendationsQuery) {
  return getRecommendations;
}